import { AxiosError } from "axios";
import { useContacts } from "hooks/useContacts";
import { useCount } from "hooks/utils/useCount";
import { useMutation } from "react-query";
import { api } from "services/api";
import { Contact } from "types/Contact";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

type RemoveContactCategoryProps = {
  contact: Contact;
}

async function removeContactCategory(contact: Contact): Promise<Contact> {
  const { data } = await api.post(`/contacts/${contact.id}/category-empty`).then(axiosSuccess).catch(axiosError);
  return data;
}

export function useRemoveContactCategory() {
  const { selectContact } = useContacts();
  const { revalidateCount } = useCount();

  return useMutation(({ contact }: RemoveContactCategoryProps) => removeContactCategory(contact), {
    onSuccess: (data: Contact) => {
      handleRequestSuccess('O setor deste contato foi removido com sucesso!');
      selectContact(data);
      revalidateCount();
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Um erro ocorreu ao remover o setor deste contato. Por favor, tente novamente!');
    }
  });
}
